// shared-lib/cabinet-runs/sinkBaseWidths.js
//
// The sink bases a KITCHEN may be built with (user ruling 2026-10-21: "offer
// whatever the product line offers"): a line with a size catalog sells its
// own — Venus's SB24 to SB42 — and every other family its width list (Generic
// Semi-Custom 24 / 27 / 30 / 33 / 36, Generic Stock 24 / 30 / 36), or the 3"
// grid for a family with none (Generic Custom builds any width; its fill packs
// that grid).
//
// Bounded below by the narrowest standard sink base, 24" — a family's width
// list is its boxes in general, and nobody sells a 21" sink base — and above
// by 36", because these are the sizes the AUTOMATIC choice picks from: the
// generator's island step-down (`kitchen-assembly/islandSinkBase.js`) and the
// fill widening a sink bay to fit its bowl (`sinkBaseWidthForRun`). 36" is the
// standard sink base, and a bowl wider than it fits is a special sold to sit
// in one. A line's 39" and 42" stay the user's to choose — the bay width chips
// offer every width the line sells (`bayWidths.js`).
//
// NOT the scan's list. A scanned bowl's reservation is `bays.sinkBaseWidthFor`
// over the standard 24 / 30 / 36 (user ruling 2026-10-21): a guess at the base
// a real bowl sits in, which must not move under a reprocessed scan because a
// line added a size.
//
// Pure. No I/O.

const { SINK_BASE_WIDTHS_IN } = require('./bays');
const { familySizes, unitsOf } = require('./vendorSizes');
const { familyById, DEFAULT_FAMILY_ID } = require('./families');
const { BASE_MODULE_WIDTHS_IN } = require('./moduleSolver');

/** The narrowest sink base anyone sells, inches. */
const NARROWEST_SINK_BASE_IN = SINK_BASE_WIDTHS_IN[0];
/** The widest sink base the automatic choice takes, inches. */
const AUTO_SINK_BASE_MAX_IN = 36;

/** Every width (inches) `family` builds a kitchen sink base at. */
function lineSinkBaseWidthsIn(family) {
  if (familySizes(family)) return unitsOf(family, 'sink-base').map((u) => u.w);
  const list = family?.spec?.widths;
  return list?.length ? list : BASE_MODULE_WIDTHS_IN;
}

/**
 * The widths (inches, narrowest first) a kitchen in `family` — the default
 * family when none is given — picks a sink base from. Empty for a line that
 * sells no kitchen sink base.
 */
function kitchenSinkBaseWidthsIn(family) {
  const widths = lineSinkBaseWidthsIn(family || familyById(DEFAULT_FAMILY_ID));
  return [...new Set(widths)]
    .filter(
      (w) =>
        w >= NARROWEST_SINK_BASE_IN - 1e-6 && w <= AUTO_SINK_BASE_MAX_IN + 1e-6
    )
    .sort((a, b) => a - b);
}

/**
 * The next sink-base width (inches) `family` sells above `widthIn`, or null.
 * NOT capped at 36": this is the one place the engine takes a line's 39" by
 * itself — a sink base beside a corner reveal that would otherwise stand 6"
 * or more wide (`cornerReveal.widenSinkBasesIntoReveals`, user ruling
 * 2026-10-26). A line that stops at 36" has none.
 */
function nextSinkBaseWidthIn(family, widthIn) {
  const above = lineSinkBaseWidthsIn(family || familyById(DEFAULT_FAMILY_ID))
    .filter((w) => w > widthIn + 1e-6)
    .sort((a, b) => a - b);
  return above.length ? above[0] : null;
}

module.exports = {
  kitchenSinkBaseWidthsIn,
  nextSinkBaseWidthIn,
  AUTO_SINK_BASE_MAX_IN,
};
